import React, { type ComponentProps } from 'react';

import { cn } from '@poseidon/components/cn';

import styles from './Draggable.module.scss';

type Props = ComponentProps<'div'> & {
  children?: React.ReactNode;
  dragElId: string;
  id: string;
};
export const Draggable = ({ id, dragElId, className, children }: Props) => {
  const dragElement = React.useCallback(
    (el: HTMLElement) => {
      let pos1 = 0;
      let pos2 = 0;
      let pos3 = 0;
      let pos4 = 0;
      const headerEl = document.getElementById(dragElId);
      if (headerEl) {
        /* if present, the header is where you move the DIV from:*/
        headerEl.onmousedown = dragMouseDown;
      } else {
        /* otherwise, move the DIV from anywhere inside the DIV:*/
        el.onmousedown = dragMouseDown;
      }

      function dragMouseDown(e: MouseEvent) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
      }

      function elementDrag(e: MouseEvent) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        el.style.top = (el.offsetTop - pos2).toString() + 'px';
        el.style.left = (el.offsetLeft - pos1).toString() + 'px';
      }

      function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
      }
    },
    [dragElId],
  );

  React.useEffect(() => {
    if (id == null) {
      return;
    }

    const element = document.getElementById(id);
    if (element) {
      dragElement(element);
    }
  }, [id, dragElement]);

  return (
    <div className={cn(styles.container, className)} id={id}>
      {children}
    </div>
  );
};
